import { IApplicationState } from '../../types/redux';

interface IExtras {
  cplDynamicCalltracking: 1 | 0;
  cplCalltracking: 1 | 0;
  '3dtour_enabled'?: 1;
  is_seo: boolean;
}

export function getNewbuildingExtra(state: IApplicationState) {
  const {
    newbuilding: { builders, sellers },
  } = state;

  const contacts = [...builders, ...sellers].filter(el => !!el.phone);

  const siteBlockId = contacts.some(el => el.dynamicCalltracking?.siteBlockId || null);
  const isFromLeadFactory = sellers.some(el => el.isLeadFactory);

  const extras: IExtras = {
    cplDynamicCalltracking: siteBlockId ? 1 : 0,
    cplCalltracking: !contacts.length || isFromLeadFactory ? 0 : 1,
    is_seo: true,
  };

  return extras;
}
